import DataMigration from "../ReactComponents/DataMigration";
import { ajax_api } from '../../Globals';

const tables = [
    {
        name: "officials",
        label: "Officials"
    },
    {
        name: "officialTypes",
        label: "Official Positions/Types"
    },
    {
        name: "itemTypes",
        label: "SP Item Types"
    },
    {
        name: "status",
        label: "Official Status"
    },
    {
        name: "committeeTypes",
        label: "Committee Types"
    },
    {
        name: "categories",
        label: "Categories"
    },
    {
        name: "committees",
        label: "Committees"
    },
    {
        name: "councils",
        label: "Councils"
    },
    {
        name: "sessions",
        label: "Sessions"
    },
    {
        name: "councilCommitteeMembers",
        label: "Council Committee Members"
    },
    {
        name: "councilMembers",
        label: "Council Members"
    },
    {
        name: "spItem",
        label: "SP Items/Ordinances/Resolutions",
        //overwrite: true,
        //skipFtp: true
    },
    {
        name: "activities",
        label: "Activities"
    },
    {
        name: "roles",
        label: "User Roles"
    }
];

const LTSMigration = _ => {
    return <DataMigration tables={tables} sync_url={ajax_api + "sync"} />
}


export default LTSMigration;